// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__vyGPX","image":"App_image__WQK6r"};